import { client } from '@/client/client.gen'

// Same-origin transport (ADR 0004): empty baseUrl so requests hit `/api/*` on the
// current origin (dev: Vite proxy → FastAPI; prod: FastAPI serves the SPA).
// `credentials: 'include'` carries the httpOnly session cookie on every call and
// keeps the contract intact if the SPA ever splits onto an `api.` subdomain.
export function configureApiClient(): void {
  client.setConfig({
    baseUrl: '',
    credentials: 'include',
  })
}
